<template>
    <div ref="modal" class="modal fade" :data-backdrop="persistent ? 'static' : null">
        <div ref="dialog" class="modal-dialog" role="document" :style="dialogStyle">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><slot name="header"></slot></h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div ref="body" class="modal-body" :style="bodyStyle">
                    <slot name="body"></slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        width: {
            type: Number,
            default: 400,
        },
        height: {
            type: [String, Number],
            default: '',
        },
        autoShow: {
            type: Boolean,
            defaut: false,
        },
        persistent: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        element() {
            return $(this.$refs.modal);
        },
        dialogStyle() {
            return {
                width: `${this.width}px`,
            };
        },
        bodyStyle() {
            if (typeof this.height === 'number') {
                return { height: `${this.height}px` };
            } else {
                return {};
            }
        },
        isVisible() {
            return this.visible;
        },
    },
    mounted() {
        this.element.on('hidden.bs.modal', this.onHidden);
        this.element.on('shown.bs.modal', this.onShown);

        this.$once('hook:destroyed', () => {
            this.element.off('hidden.bs.modal', this.onHidden);
            this.element.off('shown.bs.modal', this.onShown);
        });

        if (this.autoShow) this.show();
    },
    methods: {
        show() {
            this.element.modal('show');

            if (this.height === 'fluid') {
                this.makeHeightFluid();
            }

            this.visible = true;
        },
        makeHeightFluid() {
            const offset = 240;
            $(this.$refs.body).height($(document).height() - offset);
        },
        hide() {
            this.element.modal('hide');
        },
        onHidden() {
            this.$emit('hidden');
            this.visible = false;
        },
        onShown() {
            this.$emit('shown');
        },
        getBodyHeight() {
            return $(this.$refs.body).height();
        },
    },
};
</script>

<style lang="scss">
.modal {
    z-index: 10000000 !important;

    .modal-header {
        .close {
            font-size: 2rem;
            margin: -1.5rem -1rem -1rem auto;
        }
    }
    .modal-footer {
        text-align: right;
    }
}
</style>
